<template>
  <div>
    <!-- Modal -->
    <div 
      class="modal fade" 
      id="modalAccessoriesLost" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="lostAccessoriesModalLabel" 
      aria-hidden="true"
      ref="modal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header border-bottom">
            <img src="@/assets/icon/icon-warning-lost.png" style="width: 3rem;" class='ml-1 mr-1'/>
            <h5 class="modal-title font-weight-bold" id="lostAccessoriesModalLabel">
              {{page == 0 ? 'Lost Accessories' : 'Final Confirmation'}}
            </h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Modal Body -->
          <template v-if="!hasBatchNumber">
            <div class="modal-body" v-if="page == 0">
              <div class="p-3 bg-light rounded mb-3">
                <!-- Company Info -->
                <div class="row mb-3">
                  <div class="col-4">
                    <strong>Company Info:</strong>
                  </div>
                  <div class="col-8">
                    {{orderData.companyName}}
                  </div>
                </div>

                <!-- Order ID -->
                <div class="row mb-1">
                  <div class="col-4">
                    <strong>Order ID:</strong>
                  </div>
                  <div class="col-8">
                    <div v-if="orderData.orderCode" class="text-primary" style="cursor: pointer;" @click="toOrderDetail(orderData.orderId, orderData.orderCode,orderData.companyId)">{{orderData.orderCode}}</div>
                    <!-- <a :href="orderInfo.link" class="text-primary">
                      {{ orderData.co }}
                    </a> -->
                  </div>
                </div>
              </div>
              <!-- Accessories -->
              <div class="p-3 bg-light rounded mb-3">
                <div class="row mb-2">
                  <div class="col-4">
                    <strong>Accessories:</strong>
                  </div>
                  <div class="col-8">
                    {{ orderData.itemName }}
                  </div>
                </div>

                <!-- Total Units -->
                <div class="row mb-1">
                  <div class="col-4">
                    <strong>Total Unmatch:</strong>
                  </div>
                  <div class="col-8" v-if="pageType == 'unmatch'">
                    {{ orderData.unmatchQty}} {{ orderData.unmatchQty == 1 ? 'unit' : 'units'}}
                  </div>
                </div>
              </div>

              <!-- Number of Unmatched Units -->
              <div class="d-flex align-items-center mb-3 border-card" style="justify-content: space-between;">
                <div class="mb-0 mr-3" style="font-size: 1rem; font-weight: 600;">Number of Items to be Removed</div>
                <div class="d-flex align-items-center" style="justify-content: space-between;">
                  <div>
                    <button 
                      class="btn btn-light border mr-1 btn-qty"
                      @click="decrementUnits"
                      :disabled="lostUnits == 1"
                    >
                      −
                    </button>
                  </div>

                  <div>
                    <input 
                      type="number" 
                      class="form-control text-center no-spinner" 
                      v-model="lostUnits"
                      :max="orderData.unmatchQty"
                    >
                  </div>
                  <div>
                    <button 
                      class="btn btn-light border ml-1 btn-qty"
                      @click="incrementUnits"
                      :disabled="lostUnits >= orderData.unmatchQty"
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>

              <!-- Warning Message -->
              <div class="alert alert-danger d-flex align-items-start mb-0" role="alert">
                <small class="alert-msg">Specify how many total accessories are lost..</small>
              </div>
            </div>

            <div class="modal-body" v-if="page == 1">
              <!-- Warning Message -->
              <div class="warning-box">
                <span class="warning-label">Warning:</span> This action is permanent and cannot be undone.
                The following items will be updated immediately from the system. ddfd
              </div>
              <template v-if="orderData.ticketNo">
                <div class="section-label">Ticket Number</div>
                <div class="item-card mb-3">
                  <div
                    class="text-primary"
                    style="cursor: pointer; font-size: 14px;"
                    @click="toTicketDetail(orderData.ticketId)"
                  >
                    {{ orderData.ticketNo }}
                  </div>
                </div>

                <!-- Product Info -->
                <div class="section-label">Product Info</div>
                <div class="item-card">
                  <div class="conf-accessories-label mb-1">Accessories</div>
                  <div class="conf-product-name mb-3">
                    {{ orderData.productName || orderData.itemName }}
                  </div>
                  <hr>
                  <div class="row conf-meta-row">
                    <div class="col-6">
                      <div class="conf-meta-label">Product Code</div>
                      <div class="conf-meta-value">{{ orderData.dataAccessories.productCode || '–' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="conf-meta-label">Serial Number</div>
                      <div class="conf-meta-value">{{ orderData.dataAccessories.serialNumber || '–' }}</div>
                    </div>
                  </div>

                  <div class="row conf-meta-row mt-2">
                    <div class="col-6">
                      <div class="conf-meta-label">Stock Code</div>
                      <div class="conf-meta-value">{{ orderData.dataAccessories.stockCode || '–' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="conf-meta-label">Batch Number</div>
                      <div class="conf-meta-value">{{ orderData.dataAccessories.batchNo || '–' }}</div>
                    </div>
                  </div>
                </div>

                <div class="conf-lost-qty-row mt-3">
                  <span class="conf-lost-qty-label">Lost items Quantity</span>
                  <span class="conf-lost-qty-value">{{ lostUnits }} {{ lostUnits == 1 ? 'unit' : 'units' }}</span>
                </div>

              </template>
              <template v-else>
                <div class="section-label">Lost Items</div>

                <div class="item-card">
                  <!-- Quantity Row  -->
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <span class="item-label">Quantity:</span>
                    <span class="item-quantity">{{ lostUnits }}{{ lostUnits == 1 ? 'unit' : 'units'}}</span>
                  </div>
                  <hr></hr>
                  <!-- Accessories Name -->
                  <div>
                    <div class="item-label mb-2">Accessories Name:</div>
                    <div class="accessories-name">{{ pageType == 'unmatch' ? orderData.itemName : orderData.productName }}</div>
                  </div>
                </div>
              </template>
              
            </div>

            <div class="modal-footer border-top">
              <button type="button" class="btn btn-outline-secondary" @click="closeModal" v-if="page == 0 || pageType == 'qc'">
                Cancel
              </button>
              <button type="button" class="btn btn-outline-secondary" @click="toPage(0)" v-if="page == 1 && pageType == 'unmatch'">
                Go Back
              </button>
              <button 
                type="button" 
                class="btn btn-danger text-white" 
                @click="toPage(1)"
                :disabled="lostUnits < 1"
                v-if="page == 0"
              >
                Continue
              </button>
              <button 
                type="button" 
                class="btn btn-danger text-white" 
                @click="confirmLost"
                v-if="page == 1"
              >
                Confirm
              </button>
            </div>
          </template>
          

           <template v-else>
            <div class="modal-body">
              <div class="warning-box">
                <span class="warning-label">Warning:</span> This action is permanent and cannot be undone.
                The following items will be updated immediately from the system.
              </div>
              <!-- Order Info -->
              <div class="section-label">Order Info</div>
              <div class="item-card mb-3">
                <div class="conf-company-name">{{ orderData.companyName }}</div>
                <div
                  class="text-primary"
                  style="cursor: pointer; font-size: 14px;"
                  @click="toOrderDetail(orderData.orderId, orderData.orderCode, orderData.companyId)"
                >
                  {{ orderData.orderCode }}
                </div>
              </div>

              <!-- Product Info -->
              <div class="section-label">Product Info</div>
              <div class="item-card">
                <div class="conf-accessories-label mb-1">Accessories</div>
                <div class="conf-product-name mb-3">
                  {{ orderData.productName || orderData.itemName }}
                </div>
                <hr>
                <div class="row conf-meta-row">
                  <div class="col-6">
                    <div class="conf-meta-label">Product Code</div>
                    <div class="conf-meta-value">{{ orderData.dataAccessories.productCode || '–' }}</div>
                  </div>
                  <div class="col-6">
                    <div class="conf-meta-label">Serial Number</div>
                    <div class="conf-meta-value">{{ orderData.dataAccessories.serialNumber || '–' }}</div>
                  </div>
                </div>

                <div class="row conf-meta-row mt-2">
                  <div class="col-6">
                    <div class="conf-meta-label">Stock Code</div>
                    <div class="conf-meta-value">{{ orderData.dataAccessories.stockCode || '–' }}</div>
                  </div>
                  <div class="col-6">
                    <div class="conf-meta-label">Batch Number</div>
                    <div class="conf-meta-value">{{ orderData.dataAccessories.batchNo || '–' }}</div>
                  </div>
                </div>
              </div>

              <div class="conf-lost-qty-row mt-3">
                <span class="conf-lost-qty-label">Lost items Quantity</span>
                <span class="conf-lost-qty-value">{{ lostUnits }} {{ lostUnits == 1 ? 'unit' : 'units' }}</span>
              </div>
            </div>
             
            <!-- Modal Footer -->
            <div class="modal-footer border-top">
              <button type="button" class="btn btn-outline-secondary" @click="closeModal">
                Cancel
              </button>

              <button 
                type="button" 
                class="btn btn-danger text-white" 
                @click="confirmLost"
              >
                Confirm
              </button>
            </div>

           </template>
        

         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: 'modalAccessoriesLost',
  props: ['orderData','toOrderDetail','pageType'],
  data() {
    return {
      page : 0, // 0 for filling lost item info, 1 is for confirmation
      lostUnits: 1,
    }
  },
  methods: {
    toTicketDetail(ticketId) {
      const routerData = this.$router.resolve({path:'/resolution/detail/' + ticketId})
      window.open(routerData, '_blank')
    },
    showModal() {
      // Reset unmatched units ketika modal dibuka
      this.lostUnits = 1;
      
      // Jika pageType adalah 'qc', langsung ke page 1 (confirmation)
      // Jika pageType adalah 'unmatch', mulai dari page 0
      this.page = this.pageType === 'qc' ? 1 : 0;
      
      $(this.$refs.modal).modal('show');
    },
    closeModal() {
      $(this.$refs.modal).modal('hide');
    },
    incrementUnits() {
      // if (this.lostUnits < this.orderData.totlaQty) {
        this.lostUnits++;
      // }
    },
    decrementUnits() {
      // if (this.lostUnits > 1) {
        this.lostUnits--;
      // }
    },
    toPage(num) {
      this.page = num;
    },
    confirmLost() {
      console.log(this.orderData)
      const {orderId, dataAccessories} = this.orderData
      const {itemCode, itemGroup, itemName, stockId, batchNo, ticketDeviceId} = dataAccessories
      const payload = {
        orderId,
        itemCode : this.pageType == 'unmatch' ? Number(itemCode) : Number(stockId),
        qty: Number(this.lostUnits) || 0,
        page : this.pageType,
        batchNo,
        ticketDeviceId,
      }
      // console.log(payload)
      this.processAccessoriesLost(payload)
      // this.closeModal();
    },
    processAccessoriesLost(payload) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.post(process.env.ACCESSORIES_SET_LOST, payload, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: res.data.message,
              icon: "success",
            }).then(result => {
              this.closeModal()
              if(this.pageType == 'unmatch') {
                // this.$router.push('/return/unmatch')
                window.location.reload()
              } else {
                window.location.reload()
                // this.$router.push({
                //   path: '/return/quality-control',
                //   query: {
                //     uniqueId: '',
                //     tipe : 'All',
                //     itemPerPage: 10,
                //     page: 1
                //   }
                // })
              }
              
            })
          } else {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: `${res.data.message}`,
              icon: "error",
            })
          }
        })
        .catch(error => {
          this.loadingTable = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: `${error.response.data.message}`,
            icon: "error",
          })
        })
    },
  },
  computed: {
    // True bila accessories item ini punya batchNo yang tidak kosong
    hasBatchNumber() {
      const acc = this.orderData && this.orderData.dataAccessories;
      const batchNo = acc && acc.batchNo;
      return !!batchNo && batchNo.trim() !== '';
    },
  },
  watch: {
    lostUnits(newVal) {
      // Pastikan nilai selalu dalam range yang valid
      // let new = Number(newVal) ? Number(newVal) : 1;
      // if (Number(newVal) < 1) {
      //   this.lostUnits = 1;
      // } else 
      if(this.pageType == 'unmatch') {
        if (newVal > this.orderData.unmatchQty) {
          this.lostUnits = this.orderData.unmatchQty;
        }
      } 
      
    },
  }
}
</script>

<style scoped>
/* ── New confirmation layout styles ── */
.conf-company-name { font-weight: 600; font-size: 15px; margin-bottom: 4px; }
.conf-accessories-label { color: #6c757d; font-size: 12px; }
.conf-product-name { font-weight: 600; font-size: 15px; line-height: 1.4; }

.conf-meta-label { color: #6c757d; font-size: 12px; margin-bottom: 2px; }
.conf-meta-value { font-size: 14px; color: #212529; }
.conf-lost-qty-row {
  display: flex; justify-content: space-between; align-items: center;
  background-color: #fff5f5; border-radius: 6px; padding: 10px 14px;
}
.conf-lost-qty-label { color: #dc3545; font-size: 14px; font-weight: 500; }
.conf-lost-qty-value { color: #dc3545; font-weight: 700; font-size: 14px; }
/* Untuk Chrome, Safari, Edge, Opera */
.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Untuk Firefox */
.no-spinner[type=number] {
  -moz-appearance: textfield;
}
.alert-danger {
  color: #BE3846;
}
.alert-msg {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1%;

}
#lostAccessoriesModalLabel {
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: -0.1%;
  vertical-align: middle;
  padding-top : 0.6rem;
  margin-left: 0.5rem;
}

.warning-box {
  background-color: #fff5f5;
  border-left: 4px solid #dc3545;
  padding: 16px 20px;
  border-radius: 4px;
  margin-bottom: 24px;
  color: #721c24;
  font-size: 14px;
  line-height: 1.6;
}

.warning-label {
  color: #dc3545;
  font-weight: 600;
}

.section-label {
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}

.item-card {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 20px;
  background-color: #ffffff;
}

.item-label {
  color: #495057;
  font-size: 14px;
  margin: 0;
}

.item-quantity {
  color: #dc3545;
  font-weight: 600;
  font-size: 14px;
}

.accessories-name {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.1%;
  vertical-align: middle;

}

.btn-qty {
  width: 38px;
  height: 38px;
  font-size: 18px;
  padding: 0;
  line-height: 1;
}

.border-card {
  border: 1px solid  #CFD3D9;
  border-radius: 8px;
  padding: 10px;
}
.modal-header {
  background-color: #fff;
  padding: 1rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.font-weight-bold {
  font-weight: 600;
}

.input-group .btn {
  border-color: #ced4da;
  width: 45px;
}

.input-group .form-control {
  border-left: 0;
  border-right: 0;
}

.input-group-prepend .btn,
.input-group-append .btn {
  z-index: 0;
}

.input-group .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.btn-warning {
  background-color: #ff7f32;
  border-color: #ff7f32;
}

.btn-warning:hover {
  background-color: #e67329;
  border-color: #e67329;
}

.btn-warning:disabled {
  background-color: #ff7f32;
  border-color: #ff7f32;
  opacity: 0.65;
}

hr {
  margin: 1rem 0;
  border-top: 1px solid #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/QC/CustomComponent/ModalAccessoriesLost.vue